import { Api, DemandAnalysis } from '../api/schemas/schema'
export const logoutEventName = 'logoutUnauthorized'
export const api = () => {
   return new Api({
      baseUrl: process.env.REACT_APP_API_URL,
      customFetch: async (url, init) => {
         const response = await fetch(url, {
            ...init,
            credentials: 'include',
         })
         if (response.status === 401) {
            await fetch(`${process.env.REACT_APP_API_URL}/api/auth/logout`, {
               method: 'POST',
               credentials: 'include',
            })
            window.dispatchEvent(new Event(logoutEventName))
            return Promise.reject('Unauthorized')
         }

         return response
      },
   }).api
}

export const getDemandAnalysisQuestions = async (analysisId: string, organisationId: string): Promise<DemandAnalysis> => {
   const response = await fetch(`${process.env.REACT_APP_API_URL}/api/DemandAnalysis/${analysisId}/${organisationId}/questions`, {
      credentials: 'include',
   })
   if (response.status === 401) {
      await fetch(`${process.env.REACT_APP_API_URL}/api/auth/logout`, { method: 'POST', credentials: 'include' })
      window.dispatchEvent(new Event(logoutEventName))
      return Promise.reject('Unauthorized')
   }
   if (!response.ok) {
      const error = await response.json().catch(() => ({}))
      return Promise.reject({ status: response.status, error })
   }
   return response.json()
}
